import { render, staticRenderFns } from "./PhotopointMediaReviewView.vue?vue&type=template&id=a840b2f4&"
import script from "./PhotopointMediaReviewView.vue?vue&type=script&lang=js&"
export * from "./PhotopointMediaReviewView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports